import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
/**
 * flex width set
 *
 * @example
 *
 * ```tsx
 * `${flexWidth('auto')}`
 * // flex: 1 1 auto
 * // max-width: unset
 * // max-width: unset
 *
 *
 * `${flexWidth('500px')}`
 * // flex: 1 1 500px
 * // max-width: 500px
 * // max-width: 500px
 * ```
 */
export var flexWidth = function (width) { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1 1 ", ";\n\n  ", "\n"], ["\n  flex: 1 1 ", ";\n\n  ",
    "\n"])), width, width !== 'auto'
    ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        max-width: ", ";\n        min-width: ", ";\n      "], ["\n        max-width: ", ";\n        min-width: ", ";\n      "])), width, width) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        max-width: unset;\n        min-width: unset;\n      "], ["\n        max-width: unset;\n        min-width: unset;\n      "])))); };
var templateObject_1, templateObject_2, templateObject_3;
